import script from "./customerDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./customerDetail.vue?vue&type=script&setup=true&lang=js"

import "./customerDetail.vue?vue&type=style&index=0&id=a3bbaed4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3bbaed4"]])

export default __exports__